import { stage } from "../utils/enums";

export default Object.values(stage);
